export { default, default as Tabs } from './Tabs'
export { default as Tab } from './components/Tab'
export { default as TabTitle } from './components/TabTitle'

export { default as tabsTheme } from './themes/Tabs.theme'

export * as TabsStyles from './styles/Tabs.style'
export * as TabStyles from './components/Tab/styles/Tab.style'
export * as TabTitleStyles from './components/TabTitle/styles/TabTitle.style'

export type { TabsTheme, AppearanceKeys } from './themes/Tabs.theme.types'

export type { TabsProps } from './Tabs.types'
export type { TabProps } from './components/Tab/Tab.types'
export type { TabTitleProps } from './components/TabTitle/TabTitle.types'

export type { StyledTabsProps } from './styles/Tabs.style.types'
export type { StyledTabProps } from './components/Tab/styles/Tab.style.types'
export type { StyledTabTitleProps } from './components/TabTitle/styles/TabTitle.style.types'
